export function addResponseInterceptor(instance) {
    instance.interceptors.response.use(
      response => response,
      error => {
        if (!error.response) {
          const currentLocale = localStorage.getItem("locale") || 'en';
          const message = currentLocale === 'es'
            ? 'Error de red. Por favor, verifica tu conexión e intenta de nuevo'
            : 'Network error. Please, check your connection and try again';
  
          return Promise.reject(new Error(message));
        }
  
        return Promise.reject(error);
      }
    );
  }